export const FETCH_USERS = '@auth/FETCH_USERS';
export const FETCH_USERS_SUCCESS = '@auth/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = '@auth/FETCH_USERS_FAILURE';

export const FETCH_USER_DETAILS = '@auth/FETCH_USER_DETAILS';
export const FETCH_USER_DETAILS_SUCCESS = '@auth/FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = '@auth/FETCH_USER_DETAILS_FAILURE';
